import { IContactFunctionData } from 'types/contacts/IContactFunctionData';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from 'API/eAPITags';
import { CACHE_TIME } from '../../utilities/Constants.APIConfig';

export const ContactFunctionApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listContactFunctions: build.query<IContactFunctionData[], void>({
      query: () => `/timber/api/internal/contact-functions`,
      keepUnusedDataFor: CACHE_TIME,
      providesTags: () => [{ type: eAPITags.ContactFunctions }],
    }),
  }),
  overrideExisting: false,
});

export const { useListContactFunctionsQuery } = ContactFunctionApi;
